import { AxiosResponse } from 'axios';
import { appContextGet } from './httpCommon/appAxios.service';
import { SHIPPING_ORDER_DETAILS } from '../constants/apiEndpoints';

export const getShippingOrderDetailsByBulkId = (params: { bulkOrderId: number }): Promise<AxiosResponse<any, any>> => {
  return appContextGet(SHIPPING_ORDER_DETAILS.GET, params);
};
